export { generateCaptionHtml } from '@/utils/mediaCaption'

export function waitObject(object, maxRetry = 10, intervalTime = 100) {
  return new Promise((resolve, reject) => {
    if (object) {
      return resolve(object)
    }

    let retry = 0
    const interval = window.setInterval(() => {
      if (object) {
        window.clearInterval(interval)
        return resolve(object)
      }

      retry += 1
      if (retry >= maxRetry) {
        window.clearInterval(interval)
        return reject(new Error('Max retries reached. Object is still not available.'))
      }
    }, intervalTime)
  })
}

export function preloadImage(url) {
  const img = new Image()
  img.src = url
}
